import React, { useCallback, useMemo } from 'react';
import dayjs from 'dayjs';
import { getDayEnd, getDayStart } from 'utils';

import { DateService, useArchivedSportsbookState } from '@atlas/core';
import { Label } from '@atlas/ui';

import ResultsTimeFilterItem from 'components/Pages/Results/ResultsTimeFilter/ResultsTimeFilterItem';

const DAY_FILTER_RANGE = 7;

function getFilterDates(range) {
  return new Array(range).fill('').map((x, index) => {
    const date = dayjs().subtract(index, 'days');
    const subtitle = date.format('ddd');
    const title = DateService.getFormattedDate(date);
    const fromDate = getDayStart(date);
    const toDate = getDayEnd(date);

    return {
      fromDate,
      subtitle,
      title,
      toDate,
      today: index === 0,
    };
  });
}

const FilterDateElement = ({ filterOption, filterUpdate, fromDate, toDate }) => {
  const { subtitle, title } = filterOption;

  const isActive = useMemo(
    () => filterOption.fromDate >= fromDate && filterOption.toDate <= toDate,
    [filterOption.fromDate, filterOption.toDate, fromDate, toDate],
  );

  const handleSelectTimeFilter = useCallback(() => {
    if (isActive) return;
    filterUpdate({
      currentDate: filterOption.today,
      fromDate: filterOption.fromDate,
      toDate: filterOption.toDate,
    });
  }, [filterOption.fromDate, filterOption.toDate, filterOption.today, filterUpdate, isActive]);

  return (
    <ResultsTimeFilterItem
      isActive={isActive}
      key={title}
      onClick={handleSelectTimeFilter}
      subtitle={<Label message={subtitle} />}
      title={title}
    />
  );
};

const ResultsTimeFilter = () => {
  const { fromDate, toDate, updateArchivedSportsbookState } = useArchivedSportsbookState();

  const timeFilters = useMemo(() => {
    const filterDates = getFilterDates(DAY_FILTER_RANGE);

    return filterDates.map(filterOption => (
      <FilterDateElement
        filterOption={filterOption}
        filterUpdate={updateArchivedSportsbookState}
        fromDate={fromDate}
        key={filterOption.title}
        toDate={toDate}
      />
    ));
  }, [fromDate, toDate, updateArchivedSportsbookState]);

  return (
    <div className="history-filter">
      <div className="chips-list">{timeFilters}</div>
    </div>
  );
};

export default ResultsTimeFilter;
